module.exports = {
  app_version: '1.0.0',
  api: {
    baseurl: 'https://www.stc.team/',
    apiurl: '',
    methods: {
      tasks: 'tasks',
      process: 'process',
      results: 'results'
    }
  }
}
